import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentUpload = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentUpload' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M12,20 L12,11 M8,14 L12,10 L16,14' />
  </StyledIcon>
);
